import config from "@/config/site.json";

// ---------------------------------------------------------------------------
// All editable site content lives in `src/config/site.json`.
// This module only derives convenient, typed helpers from that JSON.
// ---------------------------------------------------------------------------

const buildWhatsappUrl = (message) =>
  `https://wa.me/${config.contact.phoneRaw}?text=${encodeURIComponent(message)}`;

export const SITE = {
  brand: config.brand.name,
  shortBrand: config.brand.short,
  tagline: config.brand.tagline,
  overline: config.brand.overline,
  description: config.brand.description,
  phone: config.contact.phone,
  phoneRaw: config.contact.phoneRaw,
  email: config.contact.email,
  address: config.contact.address,
  whatsappUrl: buildWhatsappUrl(config.whatsapp.defaultMessage),
};

export const whatsappFor = (variety) =>
  buildWhatsappUrl(config.whatsapp.varietyMessage.replace("{variety}", variety));

export const MEDIA = config.media;
export const VARIETIES = config.varieties;
export const USPS = config.usps;
export const PROCESS_STEPS = config.process;
export const STORY = config.story;
export const TESTIMONIALS = config.testimonials;
export const HERO = config.hero;
export const NAV_LINKS = config.nav;
